import React, { useState, useEffect } from 'react';
import { useOutletContext, useNavigate } from 'react-router-dom';
import { dashboardAPI } from '../services/api';

const Dashboard = () => {
  const { selectedShop } = useOutletContext();
  const navigate = useNavigate();
  
  const [metrics, setMetrics] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchMetrics = async () => {
      try {
        setLoading(true);
        setError(null);
        const response = await dashboardAPI.getSummary(selectedShop);
        setMetrics(response.data);
      } catch (err) {
        setError('Failed to load dashboard metrics. Please check your connection.');
      } finally {
        setLoading(false);
      }
    };

    fetchMetrics();
  }, [selectedShop]);

  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="animate-spin h-10 w-10 border-4 border-blue-600 rounded-full border-t-transparent"></div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="bg-red-50 border-l-4 border-red-500 p-4 rounded-md mt-4">
        <p className="text-red-700 font-medium">{error}</p>
      </div>
    );
  }


  const handleCardClick = (statusFilter) => {
    if (statusFilter === 'overdue') {
      navigate('/table?overdue=true');
    } else if (statusFilter === 'active') {
      navigate('/table?active=true');
    } else if (statusFilter) {
      navigate(`/table?status=${statusFilter}`);
    } else {
      navigate('/table');
    }
  };

  // ✅ CORRECTED MAPPING: Exact match to dashboard.py JSON response
  const total      = metrics?.total_active || 0;
  const pending    = metrics?.pending      || 0;
  const inProgress = metrics?.in_progress  || 0;
  const ready      = metrics?.ready        || 0;
  const cancelled  = metrics?.cancelled    || 0;
  const overdue    = metrics?.overdue      || 0;

  return (
    <div className="max-w-7xl mx-auto space-y-6">
      <h2 className="text-2xl font-bold text-gray-800 tracking-tight">
        Overview: {selectedShop}
      </h2>
      
      <div className="grid grid-cols-2 gap-4 md:grid-cols-3 md:gap-6">
        
        {/* Total Card */}
        <div 
          onClick={() => handleCardClick('active')} 
          className="bg-white rounded-xl shadow-sm border border-gray-200 p-5 cursor-pointer hover:shadow-md transition-shadow active:bg-gray-50"
        >
          <p className="text-sm font-medium text-gray-500">Total Active</p>
          <p className="mt-2 text-3xl font-bold text-gray-900">{total}</p>
        </div>

        {/* Pending Card */}
        <div 
          onClick={() => handleCardClick('Pending')} 
          className="bg-white rounded-xl shadow-sm border border-gray-200 p-5 cursor-pointer hover:shadow-md transition-shadow active:bg-gray-50"
        >
          <p className="text-sm font-medium text-gray-500">Pending</p>
          <p className="mt-2 text-3xl font-bold text-gray-700">{pending}</p>
        </div>

        {/* In Progress Card */}
        <div 
          onClick={() => handleCardClick('In Progress')} 
          className="bg-white rounded-xl shadow-sm border border-gray-200 p-5 cursor-pointer hover:shadow-md transition-shadow active:bg-gray-50"
        >
          <p className="text-sm font-medium text-blue-600">In Progress</p>
          <p className="mt-2 text-3xl font-bold text-blue-700">{inProgress}</p>
        </div>

        {/* Ready Card */}
        <div 
          onClick={() => handleCardClick('Ready')} 
          className="bg-white rounded-xl shadow-sm border border-gray-200 p-5 cursor-pointer hover:shadow-md transition-shadow active:bg-gray-50"
        >
          <p className="text-sm font-medium text-green-600">Ready</p>
          <p className="mt-2 text-3xl font-bold text-green-700">{ready}</p>
        </div>

        {/* Overdue Card (Always Red) */}
        <div 
          onClick={() => handleCardClick('overdue')} 
          className="bg-red-50 rounded-xl shadow-sm border border-red-300 p-5 cursor-pointer hover:shadow-md hover:bg-red-100 transition-colors active:bg-red-200"
        >
          <p className="text-sm font-bold text-red-600 flex items-center">
            <span className="mr-2">🔴</span> Overdue
          </p>
          <p className="mt-2 text-3xl font-bold text-red-700">{overdue}</p>
        </div>

        {/* Cancelled Card */}
        <div 
          onClick={() => handleCardClick('Cancelled')} 
          className="bg-gray-50 rounded-xl shadow-sm border border-gray-200 p-5 cursor-pointer hover:shadow-md transition-shadow active:bg-gray-100"
        >
          <p className="text-sm font-medium text-gray-500">Cancelled</p>
          <p className="mt-2 text-3xl font-bold text-gray-600">{cancelled}</p>
        </div>

      </div>
    </div>
  );
};

export default Dashboard;